import React, { createContext, useContext, useEffect, useState } from "react";

const ModeContext = createContext(null);

// "studio" => dark premium brand. "kid" => bright playful.
export function ModeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("gv_mode") || "studio");

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    if (mode === "studio") {
      root.classList.add("dark");
      body.classList.remove("kid-mode");
    } else {
      root.classList.remove("dark");
      body.classList.add("kid-mode");
    }
    localStorage.setItem("gv_mode", mode);
  }, [mode]);

  const toggle = () => setMode((m) => (m === "studio" ? "kid" : "studio"));

  return (
    <ModeContext.Provider value={{ mode, setMode, toggle, isKid: mode === "kid" }}>
      {children}
    </ModeContext.Provider>
  );
}

export const useMode = () => useContext(ModeContext);
